import { Api } from "../config/request";

export default {
  fileUpload(url, payload) {
    return Api.post(url, payload);
  },
  uploadFileSuccess(url, payload) {
    return Api.put(url, payload);
  },
  uploadToS3(url, file) {
    return new Promise((resolve, reject) => {
      var oReq = new XMLHttpRequest();
      oReq.addEventListener("error", function (e) {
        reject(`${e.type}: ${e.loaded} bytes transferred\n`);
      });
      oReq.onreadystatechange = function () {
        if (this.readyState == 4 && this.status == 200) {
          // Typical action to be performed when the document is ready:
          resolve(oReq.responseText);
        }
      };
      var blob = new Blob([file], { type: "application/octet-stream" });
      oReq.open("PUT", url, true);
      oReq.send(blob);
    });
  },
};
